import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';

import { usePokerSundayMillionWidget } from '../../model';
import Tile from '../Tile/Tile';

import styles from './TilesList.scss';

export interface TilesListProps {
  direction?: 'row' | 'col';
  rect?: boolean;
}

const TilesList: React.FC<TilesListProps> = ({ direction = 'col', rect = false }) => {
  const { widgetSelect, widgetConfig } = usePokerSundayMillionWidget();

  const relatedEvents = useSelector((rootState: RootState) =>
    widgetSelect.getRelatedEvents(rootState, widgetConfig)
  );

  if (!relatedEvents) return null;

  return (
    <div
      className={classNames(styles.root, {
        [styles[direction]]: direction
      })}
    >
      {relatedEvents.map((event) => (
        <Tile key={`${event.type}-${event.value}`} rect={rect} event={event} />
      ))}
    </div>
  );
};

export default TilesList;
